import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { MdLocationOn, MdWork } from "react-icons/md";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import SearchBar from "./components/SearchBar";
import { EmptyComponent } from "@/components/ui/EmptyComponent";
import { LoadingComponent } from "@/components/ui/LoadingComponent";
import IndustrialService from "@/services/IndustrialService";
import config from "@/config";

const IndustrialPark = () => {
  document.documentElement.scrollTop = 0;

  const ITEM_PER_PAGE = 12;

  const [current, setCurrent] = useState(1);
  const [filteredIndustry, setFilteredIndustry] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const query = {}
    if (searchParams.get("inputSearch")) query.inputSearch = (searchParams.get("inputSearch"))
    if (searchParams.get("codeKhuVuc")) query.codeKhuVuc = (searchParams.get("codeKhuVuc"))
    if (searchParams.get("codeTinh")) query.codeTinh = (searchParams.get("codeTinh"))

    IndustrialService.getIndustrialUrgent(query).then((res) => {
      setFilteredIndustry(res.Data);
      setLoading(false);
    });
  }, [searchParams]);

  const currentPage = filteredIndustry?.slice(
    (current - 1) * ITEM_PER_PAGE,
    current * ITEM_PER_PAGE
  );
  const onChange = (page) => {
    setCurrent(page);
  };

  const handleSearch = (query) => {
    navigate(`?${new URLSearchParams(query).toString()}`)
  }

  if (loading) {
    return <LoadingComponent />;
  }
  return (
    <div className={"bg-gray-100"}>
      <div className={"container px-4 sm:px-8 mx-auto lg:px-22 pt-12"}>
        <div className={"bg-white rounded-xl"}>
          <div className={"flex justify-between"}>
            <div
              className={
                "w-full rounded-t-xl p-5 bg-gradient-to-tl from-green-400 via-green-500 to-green-700 animate-gradient"
              }
              style={{
                backgroundSize: "200% 200%",
                animation: "gradient-animation 6s ease infinite",
              }}
            >
              <h1 className={"text-3xl text-white font-bold"}>
                Tìm khu công nghiệp
              </h1>
              <p className={"text-white"}>
                Tìm kiếm thông tin về các khu công nghiệp
              </p>
            </div>
          </div>
          <SearchBar
            onSearch={handleSearch}
          // onFiltered={handleFiltered}
          />
          <div className={"p-4 container mx-auto"}>
            <h2 className={""}>
              Tìm thấy <b>{filteredIndustry?.length}</b> thông tin liên quan
            </h2>
          </div>
          <div className="border-t border-gray-200 container p-2">
            {filteredIndustry.length ? (
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {currentPage?.map((industry, index) => (
                  <Link
                    to={`/khu-cong-nghiep/${industry.CodeKcn}`}
                    key={index}
                    className="bg-white h-full p-4 rounded-lg shadow-md flex flex-col justify-between transition-all border-2 border-transparent hover:translate-y-[-5px] duration-200 hover:shadow-2xl hover:border-primary"
                  >
                    <div className="relative pb-3 ">
                      <img
                        src={config.ImageConfig.getBanner(industry.Banner)}
                        alt="Banner"
                        className="w-full h-40 object-cover rounded bg-white shadow"
                      />
                    </div>
                    <div className="p-4 border-y border-blue-200">
                      <h3 className="text-lg font-semibold hover:underline cursor-pointer line-clamp-2">
                        {industry.NameKcn}
                      </h3>
                      <div className="flex gap-2 items-center flex-wrap justify-start mt-2 text-gray-600">
                        <div className="flex items-center gap-1 text-sm">
                          <MdLocationOn className="w-4 h-4 shrink-0" />
                          <p className="line-clamp-1">
                            Khu Vực Phía {industry.NameKhuVuc},{" "}
                            {industry.NameTinh}
                          </p>
                        </div>
                        <div className="flex items-center gap-1 text-sm mt-1">
                          <MdWork className="w-4 h-4 shrink-0" />
                          <p className="line-clamp-1">{industry.JobCount} việc làm ,</p>
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      <button className="w-full text-primary border border-primary hover:bg-primary-hover  hover:text-white  transition-all duration-300 py-2 rounded-lg font-semibold">
                        Thông tin chi tiết
                      </button>
                    </div>
                  </Link>
                ))}
                <div className="col-span-full flex justify-center">
                  {filteredIndustry.length > ITEM_PER_PAGE && (

                    <Pagination
                      current={current}
                      onChange={onChange}
                      total={filteredIndustry?.length}
                      pageSize={ITEM_PER_PAGE}
                      showSizeChanger={false}
                    />
                  )}
                </div>
              </div>
            ) : (
              <EmptyComponent description={"khu công nghiệp"} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default IndustrialPark;
